import { render, staticRenderFns } from "./intentReportTool.vue?vue&type=template&id=67a6ebbc&scoped=true"
import script from "./intentReportTool.vue?vue&type=script&lang=js"
export * from "./intentReportTool.vue?vue&type=script&lang=js"
import style0 from "./intentReportTool.vue?vue&type=style&index=0&id=67a6ebbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6ebbc",
  null
  
)

export default component.exports